import React from 'react';
import Avatar, { AvatarGroup } from 'components/common/Avatar';

// Cell renderer for recipients
const RecipientsRenderer = (params) => {
  if (!params.value || !Array.isArray(params.value) || params.value.length === 0) {
    return <span className="tw-text-slate-500">-</span>;
  }

  return (
    <div className="tw-flex tw-flex-wrap tw-gap-1 tw-text-xs tw-my-2">
      <AvatarGroup dense>
        {params.value.map((tag, idx) => {
          // Safety check: ensure tag is a string
          const tagName = typeof tag === 'object' ? tag.name || JSON.stringify(tag) : String(tag);
          return (
            <Avatar
              key={idx}
              name={tagName}
              size="m"
              className="tw-mr-3 tw-shrink-0"
            />
          );
        })}
      </AvatarGroup>
    </div>
  );
};

export default RecipientsRenderer;